import React from 'react';
import { PropTypes } from 'prop-types';
import { Modal } from '@custom-components';
import { Content } from './styles';

function BlockCardModal(props) {
  const { active, provider, closeModal, toggleVccStatus, cardId } = props;

  return (
    <Content>
      <Modal
        openModal
        smallModal
        title={`${active ? 'UNBLOCK' : 'BLOCK'} ${provider} CARD`}
        content={`You are about to ${
          active ? 'unblock' : 'block'
        } ${provider}'s card. Are you sure you want to proceed?`}
        actions={[
          {
            label: 'Cancel',
            onClick: () => {
              closeModal();
            },
            btnTheme: 'secondary'
          },
          {
            label: active ? 'Unblock' : 'Block',
            onClick: () => {
              toggleVccStatus(cardId);
              closeModal();
            },
            btnTheme: 'primary'
          }
        ]}
        handleClose={() => {
          closeModal();
        }}
      />
    </Content>
  );
}

BlockCardModal.propTypes = {
  active: PropTypes.bool.isRequired,
  provider: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  toggleVccStatus: PropTypes.func.isRequired,
  cardId: PropTypes.number.isRequired
};

export default BlockCardModal;
